<template>
  <label :class="$style['wrapper']">
    <div v-if="label" :class="$style['label']">{{ label }}</div>
    <input
      v-model="model"
      :true-value="trueValue"
      :false-value="falseValue"
      type="checkbox"
      :class="$style['input']">
    <div
      :class="$style['toggle']"
      :data-text="model === trueValue ? 'Ja' : 'Nee' " />
  </label>
</template>
<script setup lang="ts">
const model = defineModel()
defineProps<{
  label?: string,
  trueValue: any,
  falseValue: any
}>()
</script>
<style module>
.input {
  position: absolute;
  opacity: 0;
}

.wrapper {
  display: inline-flex;
  flex-direction: column;
  width: auto;
}

.toggle {
  background: var(--dark-color-40);
  border-radius: 999px;
  cursor: pointer;
  height: 2rem;
  width: 4rem;
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.toggle::after {
  content: "";
  background: var(--cta-gradient);
  border-radius: 999px;
  height: 2rem;
  width: 4rem;
  position: absolute;
  left: 0;
  z-index: 1;
  transform: translateX(-2rem);
  opacity: 0;
  transition: all var(--duration-micro-normal) var(--easing-transition);
}

.toggle::before {
  align-items: center;
  justify-content: center;
  background-color: var(--text-base);
  color: var(--background-base);
  border-radius: 999px;
  content: attr(data-text);
  font-size: 0.7rem;
  font-weight: var(--font-weight-bold);
  display: inline-flex;
  position: absolute;
  left: 2px;
  top: 2px;
  width: calc(2rem - 4px);
  height: calc(2rem - 4px);
  transition: all var(--duration-micro-normal) var(--easing-transition);
  z-index: 2;
}

.input:checked ~ .toggle::after {
  transform: translateX(0);
  opacity: 1;
}

.input:checked ~ .toggle::before {
  transform: translateX(2rem);
}

.label {
  cursor: pointer;
  font-weight: var(--font-weight-bold);
}
</style>
